module.exports = __webpack_public_path__ + "media/images/webpage/shared/instagram/qrcode-d324467ca290e55259c3c730169f263b.webp";